<div class="panel" [class.active]="toggle.checked">
  <app-form-switch
    labelPosition="before"
    [inline]="!toggle.checked || viewType === 'table'"
    [formControl]="form.get('status')"
    [matTooltip]="customTooltip || getTooltip(true)"
    [disabled]="(isEditing$ | async) || disabled"
    #toggle
  >
    {{ label }}
  </app-form-switch>
  <div *ngIf="toggle.checked && viewType !== 'table'">
    <div class="d-flex gap-3 flex-wrap">
      <ng-container *ngIf="delayed">
        <app-notify-automation-delayed
          [ctrl]="form.get('delayed')"
          [showLabel]="false"
          [disabled]="isEditing$ | async"
        ></app-notify-automation-delayed>
      </ng-container>
      <ng-container *ngIf="filterByCategories">
        <mat-form-field2 [showLabel]="false" style="min-width: 13rem">
          <mat-label i18n>Select Categories</mat-label>
          <app-select
            [items]="categories"
            bindValue="value"
            bindLabel="label"
            [formControl]="form.get('categories')"
            [multiple]="true"
            i18n-placeholder
            i18n-matTooltip
            placeholder="Apply to all categories"
            matTooltip="Select the categories you want to send the notification"
            [disabled]="isEditing$ | async"
          >
          </app-select>
        </mat-form-field2>
      </ng-container>
      <ng-container *ngIf="isTimeBasedEvent && isTimeEditable">
        <app-automation-time-options
          [form]="form"
          [showLabel]="false"
          class="d-flex gap-3"
        ></app-automation-time-options>
      </ng-container>
      <ng-container *ngIf="template">
        <button class="btn btn-secondary-info" (click)="info.onEditTemplate()" [disabled]="isEditing$ | async">
          <i class="cs-icon cs-icon-pencil"></i>
          <ng-container i18n>Template</ng-container>
        </button>
      </ng-container>
      <ng-container *ngIf="lateBookings">
        <mat-checkbox
          [formControl]="form.get('late_bookings')"
          [disabled]="isEditing$ | async"
          class="mt-2"
          matTooltip="Enable this checkbox if trigger should be fired for a booking which is confirmed/created after the rental checkin time is passed"
          >Run for Late Bookings</mat-checkbox
        >
      </ng-container>
    </div>
  </div>
</div>

<app-autopilot-automation-info
  [automationGroup]="automationGroup"
  [event]="event"
  [eventSourceType]="eventSourceType"
  [template]="template"
  [class.d-none]="viewType !== 'table'"
  #info
></app-autopilot-automation-info>
